import DelegatedTokenManager from './DelegatedTokenManager';

class CoreApiTokenManager extends DelegatedTokenManager {}

const coreApiTokenManager = new CoreApiTokenManager('cimpo');
export default coreApiTokenManager;
